
export const PAGES = {
  allTrees: 'Все деревья',
  myTrees: 'Мои деревья',
  users: 'Пользователи',
  map: 'Карта',
  profile: 'Настройка профиля',
  login: 'Войти',
  registration: 'Регистрация',
  tree: 'Карточка дерева',
  user: 'Карточка пользователя',
  editTree: 'Редактирование дерева',
  addTree: 'Создание дерева'
}